const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    reviewratingEle: document.querySelector('.product-details-wrapper [data-hulkapps-reviews]'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  if (selectors.productMedia != null) {
    
 
  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
}
  class templateProductJS {
    constructor() {
        if(selectors.reviewratingEle){
            selectors.reviewratingEle.addEventListener('click', (event)=>{
                event.preventDefault();
                const reviewSection = document.querySelector('#hulk__product-review');
                if(reviewSection) reviewSection.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            });
        }
      
    }
}

typeof templateProductJS !== 'undefined' && new templateProductJS();
